/* Abdilla Franchise — header scroll-spy, reveal, count-up, franchise tabs + drawer */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('af-js');

  /* ---------- reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.af-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) {
      var r = e.getBoundingClientRect();
      if (r.top < window.innerHeight) e.classList.add('is-in'); else io.observe(e);
    });
  }

  /* ---------- count-up ---------- */
  function initCount() {
    document.querySelectorAll('[data-count]').forEach(function (el) {
      var raw = el.getAttribute('data-count'); var m = raw.match(/^(\D*)(\d+)(.*)$/);
      if (!m || reduce || el.dataset.done) return;
      var target = parseInt(m[2], 10); if (target > 3000) return;
      el.dataset.done = '1';
      var start = target > 1900 ? target - 6 : 0, t0 = null, dur = 1100;
      function step(ts) { if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / dur); var e = 1 - Math.pow(1 - p, 3);
        el.textContent = m[1] + Math.round(start + (target - start) * e) + m[3]; if (p < 1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    });
  }

  /* ---------- header scroll-spy + highlight ---------- */
  function initSpy() {
    var hdr = document.querySelector('[data-af-header]'); if (!hdr) return;
    var links = Array.prototype.slice.call(hdr.querySelectorAll('[data-spy-link]'));
    var hl = hdr.querySelector('.af-hdr__hl');
    var deskLinks = links.filter(function (a) { return a.closest('.af-hdr__nav'); });
    var map = {};
    links.forEach(function (a) { var h = a.getAttribute('href') || ''; var i = h.indexOf('#'); if (i > -1) { var id = h.slice(i + 1); (map[id] = map[id] || []).push(a); } });
    var ids = Object.keys(map).filter(function (id) { return document.getElementById(id); });
    function move(a) {
      if (!hl) return;
      if (!a) { hl.style.opacity = 0; return; }
      var ul = a.closest('ul'); var r = a.getBoundingClientRect(), u = ul.getBoundingClientRect();
      hl.style.left = (r.left - u.left) + 'px'; hl.style.width = r.width + 'px'; hl.style.opacity = 1;
    }
    function update() {
      var y = window.innerHeight * 0.35, current = null;
      ids.forEach(function (id) { var el = document.getElementById(id); var r = el.getBoundingClientRect(); if (r.top <= y && r.bottom > y) current = id; });
      links.forEach(function (a) { a.classList.remove('is-active'); });
      if (current) map[current].forEach(function (a) { a.classList.add('is-active'); });
      move(deskLinks.filter(function (a) { return a.classList.contains('is-active'); })[0]);
    }
    var ticking = false;
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { update(); ticking = false; }); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
    var burger = hdr.querySelector('[data-af-burger]');
    if (burger) {
      burger.addEventListener('click', function (e) { if (e.target.closest('a')) burger.removeAttribute('open'); });
      document.addEventListener('click', function (e) { if (burger.open && !burger.contains(e.target)) burger.removeAttribute('open'); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') burger.removeAttribute('open'); });
    }
  }

  /* ---------- franchises: tabs + drawer ---------- */
  function initFranchises(root) {
    if (!root || root.dataset.afReady) return; root.dataset.afReady = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls')); if (p) p.hidden = !on;
      });
      if (focus) tab.focus();
      tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var n = null; if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length]; if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (n) { e.preventDefault(); select(n, true); }
      });
    });
    var drawer = root.querySelector('[data-af-drawer]'); if (!drawer) return;
    var content = drawer.querySelector('[data-af-drawer-content]'); var box = drawer.querySelector('[role="dialog"]'); var lastFocus = null;
    function open(id, trigger) {
      var tpl = document.getElementById(id); if (!tpl) return;
      content.innerHTML = ''; content.appendChild(tpl.content.cloneNode(true));
      lastFocus = trigger; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('af-lock'); box.scrollTop = 0;
      setTimeout(function () { drawer.querySelector('.af-drawer__close').focus(); }, 60);
    }
    function close() {
      drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('af-lock');
      if (lastFocus) lastFocus.focus();
    }
    root.addEventListener('click', function (e) { var b = e.target.closest('[data-af-open]'); if (b) open(b.getAttribute('data-af-open'), b); });
    drawer.addEventListener('click', function (e) { if (e.target.closest('[data-af-close]')) close(); });
    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var f = box.querySelectorAll('a[href],button,[tabindex]:not([tabindex="-1"])'); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  function init() {
    initReveal(); initCount(); initSpy();
    document.querySelectorAll('[data-af-franchises]').forEach(initFranchises);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
